export default class ItemPayload {
    public shareholderId: number | null = null;
    public share: number | null = null;

    constructor(shareholderId: number | null = null, share: number | null = null) {
        this.shareholderId = shareholderId;
        this.share = share;
    }
}
